import axios from 'axios'
import React, { useState, useEffect } from 'react'

const PreviewSurvey = ({handleInput}) => {

  const [ loading , setLoading ] = useState(false)
  const [ surveyQuestions , setSurveyQuestions ] = useState([])
  const [ totalSurveyQuestions, setTotalSurveyQuestions] = useState(0)

  useEffect(() => {
      setLoading(true)
      axios.post(`${ process.env.REACT_APP_BASE_URL }/survey/question`)
      .then(
        res => {
           if( res.data.success ){
              setSurveyQuestions(res.data.questions)
              let total = 10 ;
              res.data.questions.forEach( survey => {
                  total += survey.questions.length;                 
              });
              setTotalSurveyQuestions( total )
              setLoading(false)
           }
        }
      )
  }, [])

  return (
      <React.Fragment>
         <div className='w-[70%] mt-5 grid grid-cols-2 gap-8 pl-8'>
            <div className='rounded-lg border border-gray-300 px-5 py-2'>
                <h6 className='text-sm font-semibold text-gray-700'> 360 degree feedback -self </h6>
                <p className='text-xs text-gray-700 mt-3 pb-2'> { loading ? 0 : totalSurveyQuestions } Questions </p>
                 <input 
                            className='admin-form-check'  
                            type='radio' name='survey_type' 
                            id='inlineRadio1' value={ 'self' }
                            defaultChecked = { true }
                            onChange = { handleInput }
                 />
                <div className='flex justify-end -mt-2'>
                        <div className='text-center' data-bs-toggle='modal' id='preview-modal' data-bs-target='#preview-survey'>
                            <span className='bi bi-pencil text-red-500 text-md'></span>
                            <button type='button' className='text-xs mt-1 block'> Preview </button>
                        </div>
                </div>
            </div>             

            <div className='rounded-lg border border-gray-300 px-5 py-2'>
                <h6 className='text-sm font-semibold text-gray-700'> 360 degree feedback survey Manager </h6>
                <p className='text-xs text-gray-700 mt-3 pb-2'> { loading ? 0 : totalSurveyQuestions } Questions </p>
                <input 
                            className='admin-form-check'  
                            type='radio' name='survey_type' 
                            id='inlineRadio1' value={ 'survey manager' }                            
                            onChange = { handleInput }
                />
                <div className='flex justify-end -mt-2'>
                        <div className='text-center' data-bs-toggle='modal' id='preview-modal' data-bs-target='#preview-survey'>
                            <span className='bi bi-pencil text-red-500 text-md'></span>
                            <button type='button' className='text-xs mt-1 block'> Preview </button>
                        </div>
                </div>
            </div>

            <div className='rounded-lg border border-gray-300 px-5 py-2'>
                <h6 className='text-sm font-semibold text-gray-700'> 360 degree feedback survey peers </h6>
                <p className='text-xs text-gray-700 mt-3 pb-2'> { loading ? 0 : totalSurveyQuestions } Questions </p>
                <input 
                            className='admin-form-check'  
                            type='radio' name='survey_type' 
                            id='inlineRadio1' value={ 'survey peers' }                             
                            onChange = { handleInput }
                />
                <div className='flex justify-end -mt-2'>
                        <div className='text-center' data-bs-toggle='modal' id='preview-modal' data-bs-target='#preview-survey'>
                            <span className='bi bi-pencil text-red-500 text-md'></span>
                            <button type='button' className='text-xs mt-1 block'> Preview </button>
                        </div>
                </div>
            </div>

            <div className='rounded-lg border border-gray-300 px-5 py-2'>
                <h6 className='text-sm font-semibold text-gray-700'> 360 degree feedback direct report </h6>
                <p className='text-xs text-gray-700 mt-3'> { loading ? 0 : totalSurveyQuestions } Questions </p>
                <input 
                            className='admin-form-check'  
                            type='radio' name='survey_type' 
                            id='inlineRadio1' value={ 'direct report' }                             
                            onChange = { handleInput }
                />
                <div className='flex justify-end -mt-2'>
                        <div className='text-center' data-bs-toggle='modal' id='preview-modal' data-bs-target='#preview-survey'>
                            <span className='bi bi-pencil text-red-500 text-md'></span>
                            <button type='button'  className='text-xs mt-1 block'> Preview </button>
                        </div>
                </div>
            </div>
        </div>

        <div className='modal fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto' id='preview-survey' tabIndex='-1' aria-labelledby='exampleModalLgLabel' aria-modal='true' role='dialog'>
            <div className='modal-dialog modal-xl modal-dialog-scrollable relative pointer-events-none'>
            <div className='modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current'>                                    
            <div class='modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md'>
              <h5 class='text-lg flex items-center font-medium leading-normal text-gray-800' id='exampleModalXlLabel'>
                  <i className='mx-2 bi bi-eye text-2xl'></i>
                  Preview Survey
              </h5>
              <button type='button'
                class='btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline'
                data-bs-dismiss='modal' aria-label='Close'></button>
            </div>
                <div className='modal-body relative p-4 px-8 xl:px-12'>
                      <img src="/assets/preview-evaluator-logo.PNG" alt="survey logo" className='w-[100px] h-[90px]' />
                     <h6 className='text-xl mt-3 text-gray-800'>
                         Hello <span className='text-green-small font-medium m'> Participant</span>, this questionnaire is
                         about your perception of <span className='text-green-small font-medium ml-1'> Your Leadership</span>
                     </h6>
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                        You must enter answers for All of the questions in the questionnaire.
                     </p>
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                         They relate to your perception of your own style and behaviour. This information is vital
                         for your report. As far as possible try to base your answers on actual self-observation
                         of your behaviour.
                     </p>                      
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                         The marking scale is 1-5, where 1 is the lowest score and 5 is the highest score.
                         If you really can't answer a question then you can tick the "Dont Know" box.
                     </p>
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                        You must  answers  every questions below including any pre text question.
                        If you have no comments to make please enter N/A but do not leave the box blank.
                     </p>
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                         The exact interpretation of the marking scale will depend on the wordin of the questionm,
                         but to help you choose answer best applies you may find the table below useful.
                     </p>
                     <p className='text-[14px] mt-[25px] text-gray-700 xl:w-[90%]'>
                         For support you can email: <span className='text-red-500 ml-2'> 
                              user@email.com
                          </span>
                     </p>
                        { surveyQuestions.length && 
                             <SurveyQuestions surveyQuestions={ surveyQuestions } 
                             /> 
                        }                        
                        <div className='flex justify-end mt-5'>
                           <button className='py-2 text-sm mr-8 px-8 text-white bg-red-500 rounded-lg' data-bs-dismiss='modal' aria-label='Close'>
                                Back <i className='bi ml-1 bi-arrow-right'></i>
                            </button>
                      </div>
                     </div>                      
                   </div>                                        
                </div>
            </div>       
    </React.Fragment>
  )
}


const SurveyQuestions = ({ surveyQuestions }) => {
     return (
        <div>
             {
                surveyQuestions.map( (surveyQuestion,id) => {
                     return(
                          <React.Fragment key={id}>
                              <h6 className='text-md mt-12 flex justify-between'>
                                    <span className='text-green-small capitalize text-lg'>{surveyQuestion.category}</span>
                                    <div className='text-sm w-[390px] flex justify-between'>
                                        <span>Never</span>
                                        <span>Rarely</span>
                                        <span>Sometimes</span>
                                        <span>Often</span>
                                        <span>Always</span>
                                    </div>
                              </h6>
             <div className='bg-gray-100 py-4 mt-2 px-3'>
                {
                   surveyQuestion.questions.map(
                       (survey,id) => {
                        return(
                              <div key={ survey.id } className='flex justify-between items-center'>
                                 <p className='text-sm text-gray-800'>  { survey.qusetion }. </p>
                                   <div className='text-sm w-[380px] flex justify-between mb-8 bg-white px-2 py-3'>                                     
                                           <input 
                                                className='admin-form-check-lg'  
                                                type='radio' name={'survey-preview' + id } 
                                                id='inlineRadio1' value={ 1 }
                                                defaultChecked = { true } 
                                                data-bs-toggle='tooltip' 
                                                data-bs-placement='bottom'
                                                title='Never'                          
                                                />                                    
                                             <input 
                                                className='admin-form-check-lg'  
                                                type='radio' name={'survey-preview' + id } 
                                                id='inlineRadio1' value={ 1 }   
                                                data-bs-toggle='tooltip' 
                                                data-bs-placement='bottom'
                                                title='Rarely'                                                              
                                                />                                    
                                             <input 
                                                className='admin-form-check-lg'  
                                                type='radio' name={'survey-preview' + id } 
                                                id='inlineRadio1' value={ 1 }   
                                                data-bs-toggle='tooltip' 
                                                data-bs-placement='bottom'
                                                title='Sometimes'                                                              
                                                />                                    
                                             <input 
                                                className='admin-form-check-lg'  
                                                type='radio' name={'survey-preview' + id} 
                                                id='inlineRadio1' value={ 1 } 
                                                data-bs-toggle='tooltip' 
                                                data-bs-placement='bottom'
                                                title='Often'                                                                
                                                />                                    
                                             <input 
                                                className='admin-form-check-lg'  
                                                type='radio' name={'survey-preview' + id } 
                                                id='inlineRadio1' value={ 1 } 
                                                data-bs-toggle='tooltip' 
                                                data-bs-placement='bottom'
                                                title='Always'                                                                
                                                />                                     
                                          </div>
                                        </div>
                                         )
                                       }
                                     )
                                   }
                             </div>
                          </React.Fragment>
                     )
                })
             }
       </div>
     )
}
export default PreviewSurvey